import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'vs-filmstrip-navigation',
  styleUrls: ['_filmstrip.scss'],
  shadow: false,
})
export class VsFilmstripNavigation {
  /**
   @shortDescription Reference of parent Filmstrip
   @controlName parentFilmstripRef */
  @Prop() parentFilmstripRef: any = {};

  /**
   @shortDescription Boolean to toggle Next Arrow
   @controlName showNext */
  @Prop() showNext: boolean;

  /**
   @shortDescription Boolean to toggle Prev Arrow
   @controlName showPrev */
  @Prop() showPrev: boolean;

  /**
   @shortDescription Function to handle Action on Next Arrow click
   @controlName onRightArrowClick */
  @Prop() onRightArrowClick: any;

  /**
   @shortDescription Function to handle Action on Prev Arrow click
   @controlName onLeftArrowClick */
  @Prop() onLeftArrowClick: any;

  /**
   @shortDescription Boolean to set navigation arialabel
   @controlName isNavigationHidden */
  @Prop() isNavigationHidden: boolean = true;

  @State() filmstripRef: any = {};

  componentWillLoad() {
    this.filmstripRef = this.parentFilmstripRef.stateObject;
  }

  private handleSlideHover = (e: MouseEvent) => {
    e.preventDefault();
    this.parentFilmstripRef.handleSlideCancel(e);
  };

  private showPrevButton;
  private showNextButton;

  render() {
    this.showPrevButton = this.filmstripRef.isRtl ? this.showNext : this.showPrev;
    this.showNextButton = this.filmstripRef.isRtl ? this.showPrev : this.showNext;
    return (
      <div>
        {this.showPrevButton && (
          <button
            class="vs-fs-btn vs-prev"
            tabindex="-1"
            data-role="button"
            aria-hidden={this.isNavigationHidden ? "true" : "false"}
            aria-label={this.filmstripRef.ariaLabelLeftArrow}
            aria-disabled={this.filmstripRef.prevArrowAriaDisabled}
            onClick={this.onLeftArrowClick}
            onMouseMove={this.handleSlideHover}
          >
            <span>{this.filmstripRef.ariaLabelLeftArrow}</span>
          </button>
        )}
        {this.showNextButton && (
          <button
            class="vs-fs-btn vs-next"
            tabindex="-1"
            data-role="button"
            aria-hidden={this.isNavigationHidden ? "true" : "false"}
            aria-label={this.filmstripRef.ariaLabelRightArrow}
            aria-disabled={this.filmstripRef.nextArrowAriaDisabled}
            onClick={this.onRightArrowClick}
            onMouseMove={this.handleSlideHover}
          >
            <span>{this.filmstripRef.ariaLabelRightArrow}</span>
          </button>
        )}
      </div>
    );
  }
}
